import * as FilePond from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// File Upload - FilePond
if (FilePond) {
    if (FilePondPluginImagePreview) {
        FilePond.registerPlugin(FilePondPluginImagePreview)
    }

    document.querySelectorAll("[data-filepond]").forEach((fp) => {
        FilePond.create(fp, { credits: false })
    })
}
